<template lang="pug">
.section
  .section-header
    h1 {{ $t("ui.theme_purchased") }}
  .section-body(style="max-width:1200px;")
    .row
      .col-12
        .card.mb-0
          .card-header
            .row.col-12
              .form-group.mr-2
                DateRangePicker(:value="dateRange" @update="getData")

              .form-group.mb-1
                SubmitButton(
                  :loading="loading"
                  icon="fa fa-search"
                  :text="$t('ui.search')"
                  type="button"
                  @click="getThemePurchasedList(true)"
                  variant="primary"
                  size="sm"
                )
          .card-body
            .row
              .col-10.mb-1
                b-pagination.float-left(
                  size="sm"
                  hide-ellipsis
                  :total-rows="totalRow"
                  :per-page="getPageSize"
                  v-model="currentPage"
                  @input="changedPage($event)")
              .col-2.mb-1
                b-input-group(:prepend="$t('ui.page_size')" size="sm")
                  b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize" size="sm")
              .col-12
                .clusterize-scroll.table-responsive
                  table.table.table-sm.table-bordered.table-striped.table-hover
                    thead.thead-light
                      tr
                        th.text-center(width="3%")
                          span #
                        //- th(width="5%")
                        //-   span(:title="$t('ui.provider_type')") {{ $t('ui.provider_type') }}
                        th(width="6%")
                          span(:title="$t('ui.theme_code')") {{ $t('ui.theme_code') }}
                        th.text-center(width="4%")
                          span(:title="$t('ui.total_purchased')") {{ $t('ui.total_purchased') }}
                        th.text-right(width="5%")
                          span(:title="$t('ui.purchased_date')") {{ $t('ui.purchased_date') }}
                    tbody.clusterize-content
                      tr(v-if="themePurchasedList.length == 0")
                        td(colspan="11").text-center
                          span {{ $t('message.no_data_available') }}
                      tr(v-for="(item, index) in themePurchasedList")
                        td.text-center
                          span(:title="index + 1") {{ index + 1 }}
                        //- td
                        //-   span(:title="item.provider_type") {{ item.provider_type }}
                        td
                          span(:title="item.theme_code") {{ item.theme_code }}
                        td.text-center
                          span.font-weight-bold(:title="item.total_purchase") {{ item.total_purchase }}
                        td.text-right
                          span(:title="getDate(item.purchased_dt)") {{ getDate(item.purchased_dt) }}

</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import DateRangePicker from "@/library/DateRangePicker.vue";
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';

export default {
  components: {
    SubmitButton,
    DebounceInput,
    DateRangePicker
  },
  data: () => ({
    loading: false,
    themePurchasedList: [],
    dateRange: {
      startDate: null,
      endDate: null,
    },
    currentPage: 1,
    totalRow: 0,
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    accountType() {
      return this.$store.getters.accountType;
    },
    isAdmin() {
      return this.$store.getters.accountType === 5;
    },
    isAdminMaster() {
      return [3,5].includes(this.$store.getters.accountType);
    }
  },
  mounted: function() {
    this.dateRange.startDate = this.$moment(new Date).format('YYYY-MM-DD');
    this.dateRange.endDate = this.$moment(new Date).format('YYYY-MM-DD');

    if(this.$store.getters.sessionToken) {

      if(!this.isOperator) {
        if (this.$store.getters.reportStatement.start_date && this.$store.getters.reportStatement.end_date) {
          this.dateRange.startDate = this.$store.getters.reportStatement.start_date;
          this.dateRange.endDate = this.$store.getters.reportStatement.end_date;
        }
      }

      this.getThemePurchasedList(true);
    }
  },
  methods: {
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentPage = 1;
      this.getThemePurchasedList(true);
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      this.getThemePurchasedList();
    },
    getData(currentValue) {
      this.dateRange.startDate = this.$moment(currentValue.startDate).format('YYYY-MM-DD');
      this.dateRange.endDate = this.$moment(currentValue.endDate).format('YYYY-MM-DD');
      this.getThemePurchasedList(true);
    },
    getDate(dateTime) {
      if(dateTime == null) return;
      let convertDateFormat = new this.$moment(dateTime).format("YYYY-MM-DD");
      return convertDateFormat;
    },
    setReportStatementParam: function() {
      var json = {
        start_date: this.dateRange.startDate,
        end_date: this.dateRange.endDate
      };
      this.$store.dispatch("user/setReportStatementParam", json);
    },
    getThemePurchasedList: function(isSearch) {
      this.setReportStatementParam();
      let url = config.themeCategoryUrl();

      if (isSearch) this.currentPage = 1;

      var json = {
        auth_token: this.$store.getters.sessionToken,
        action_by: this.$store.getters.loginId,
        page_number: this.currentPage,
        page_size: this.getPageSize,
        start_date: this.dateRange.startDate,
        end_date: this.dateRange.endDate,
      }

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;

              if (this.feedback.success == true) {
                this.themePurchasedList = response.data.dt;
                this.totalRow = this.themePurchasedList.length > 0 ? this.themePurchasedList[0].totalrows : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>